import { EntityPresenterMode, isStaticMode } from './presenterEntityMode';

import type { Maybe } from '@nova/core';
import type { PresenterPlaceholderData } from './presenterPlaceholder';
import type { YardAreaDetails } from './yardAreaPresenterShared';

export function nestedAreaPresenterDataProps(
  mode: EntityPresenterMode,
  data: {
    area?: Maybe<YardAreaDetails | PresenterPlaceholderData<YardAreaDetails>>;
  }
) {
  if (isStaticMode(mode)) {
    return {
      staticAreaData: (data.area ?? null) as Maybe<YardAreaDetails>
    };
  }

  return {
    placeholderAreaData: (data.area ?? null) as Maybe<PresenterPlaceholderData<YardAreaDetails>>
  };
}
